module.exports = "https://www.gc-pro.gnp.com.mx/1649e6a88bdea209ca715c0c5e249e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/directorio/3.png
// module id = 1024
// module chunks = 0 1